/** @format */

import { LoggerLevel } from '@shared/data-access/services';
import { chain } from '@core/chain';
import { devEnvironmentDefaults } from '@shared/data-access/config';

const redirectingServiceBase = '/myaccount/services/redirectingservice';
const baseUrl = '//localhost:3000';

const ceopsUrls = {
	local: 'http:localhost:6001',
	perf: 'https://ceops.dickssportinggoods.com/perf'
};

export const commonEnvironment: IEnvironment = {
	environmentName: 'dev',
	api: {
		homr: {
			baseUrl,
			previewLinks: true,
			proxy: {
				path: `/dcsg-ngx-home/homr/v2/api/`,
				timeout: '15000'
			},
			url: 'https://dev-home-dsg-dcsg-ngx.iso.an01.pcf.dcsg.com/dcsg-ngx-home/homr/v2/api',
			scene7Url: '//dks.scene7.com/is/image/dksfed/',
			scene7UrlCDN: '//dks.scene7.com/is/image/dkscdn/'
		},
		reactMarginals: {
			header: {
				AZ: 'https://perf-ecom-responsive-header-page.iso.an01.pcf.dcsg.com',
				AZ2: 'https://perf-ecom-responsive-header-page.iso.an01.pcf.dcsg.com',
				VS: 'https://perf-ecom-responsive-header-page.iso.an01.pcf.dcsg.com'
			},
			footer: {
				AZ: 'https://perf-ecom-footer-page.iso.an01.pcf.dcsg.com',
				AZ2: 'https://perf-ecom-footer-page.iso.an01.pcf.dcsg.com',
				VS: 'https://perf-ecom-footer-page.iso.an01.pcf.dcsg.com'
			},
			calia: {
				AZ: 'https://perf-calia-navigation.iso.an01.pcf.dcsg.com',
				AZ2: 'https://perf-calia-navigation.iso.an01.pcf.dcsg.com',
				VS: 'https://perf-calia-navigation.iso.an01.pcf.dcsg.com'
			},
			proxy: {
				path: `/marginals/`,
				timeout: 15000
			},
			footerHTMLId: 'react-footer-insert' //'responsive-footer'
		},
		seoByChain: `https://api-search.${chain.seoIdentifier}.com/`,
		spring: {
			baseUrl,
			gatewayUrl: 'https://gateway-server.iso.gp01.pcf.dcsg.com/',
			autoSuggestUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/',
			searchTermUrl: 'https://prod-catalog-product-api.dickssportinggoods.com/',
			taxonomyUrl: 'https://browse.dickssportinggoods.com/dcsg-ngx-category/taxo/api/',
			microServiceProxy: {
				logger: {
					path: `/maui/spring/msvc/logger/`,
					timeout: '30000'
				},
				recommendations: {
					path: '/api/spring/msvc/ds/v1/',
					timeout: '15000'
				}
			}
		},
		esb: {
			baseUrl,
			gatewayUrl: 'https://gateway.dksxchange.com/',
			gatewayUrlProxy: {
				browser: '/dcsg-ngx-header/esb/api/',
				server: 'http://localhost/dcsg-ngx-header/esb/api/'
			},
			promotions: {
				apiKey: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
				env: 'prdstage',
				previewTime: '',
				channelId: '-1'
			}
		},
		brandify: {
			brandifyBaseUrl: 'https://hosted.where2getit.com/'
		},
		esbBaseUrl: 'https://gateway.dcsg.com/',
		footerUrl: 'https://ceops.dickssportinggoods.com/',
		tickerUrl: 'https://fdhmfhecfi.execute-api.us-east-1.amazonaws.com/prod/',
		seo: 'https://api-search.dickssportinggoods.com/',
		ceops: ceopsUrls.perf,
		elastic: {
			availability: `${redirectingServiceBase}/availabilityservice`,
			searchTermUrl: 'https://prod-catalog-product-api.dickssportinggoods.com/'
		},
		avsApi: {
			origin: 'https://avs.dickssportinggoods.com',
			baseUrl: '/avs/verifyAddress',
			healthCheckUrl: '/avs/health',
			proxyPath: '/myaccount'
		},
		avsApiV2: {
			origin: 'https://avs.dickssportinggoods.com',
			baseUrl: '/v2/address/verification',
			proxyPath: '/myaccount'
		},
		myLocker: {
			path: '/v1/mylocker'
		},
		criteo: {
			baseUrl: 'https://d.us.criteo.com/delivery/retailmedia?',
			nolog: 1,
			partnerId: {
				dsg: 25953,
				gg: 35855
			}
		}
	},
	apiTokens: {
		brandify: {
			storeLocator: {
				dsg: '8D669860-73FB-11E8-8752-FF2F0D70A832',
				gg: 'CE23B360-C828-11E4-B146-ED9AA38844B8'
			}
		},
		esb: {
			api: '38d00cb0-6e1b-11e6-8390-8c24708cfd68',
			api2: '9b59c9e0-6710-11e7-bdcc-80098dffd0fa',
			identity: 'af727360-d115-11e5-ab08-be8d24eccbe9',
			myaccount: 'd0b85d50-d115-11e5-ab08-b8fc4c91c2b3'
		},
		contentAPI: {
			key: 'VDJSNWMzTmxlVUpsZEdFPSA5U1QmWTI8PWF8R0IoOWtBLEdVYzsmY1JMelBYI2k='
		},

		exComm: {
			baseUrl: '/myaccount/services/redirectingservice/dev/apimservice',
			apimSecret: '0b744db64f444d208e5d5928c0b0a943'
		},
		party: {
			partnerKey: 'botf',
			secretKey: 'ASfCzTQyKvuuV8ocnzPP'
		},
		branchIo: {
			dsg: {
				branchKey: 'key_test_in8tgmyh2zSYAYBtXoJ5pmfawxokBxeA'
			},
			gg: {
				branchKey: 'key_test_hb1rffEb2zS0SPDHxfzTljapuxlgxZEv'
			}
		}
	},
	catOvrGrpId: {
		dsg: '3074457345618270104',
		gg: '10501',
		pl: '',
		g3: ''
	},
	searchbyTermTypeParam: '1000',
	logging: {
		client: {
			level: LoggerLevel.INFO
		},
		xhr: {
			level: LoggerLevel.OFF,
			url: 'https://log-publisher.cfapps.io/publish'
		}
	},
	esbEnvironmentHeader: 'auxlive',
	inventory: {
		locationId: 0
	},
	apiAuthKeys: {
		partnerKey: 'myaccount_ui',
		secretKey: 'ESETXC1V1Zim2jwUL1lw'
	},
	pricing: {
		path: '/discount/details/',
		env: 'http://dcsgnp-dev.apigee.net/',
		esbEnvironmentHeader: 'prdlive'
	},
	production: true,
	thirdParty: {
		auth0: {
			...devEnvironmentDefaults.thirdParty.auth0
		},
		btt: {
			dsg: 'https://dsg2.btttag.com/btt.js',
			gg: 'https://golfgalaxy2.btttag.com/btt.js',
			pl: '',
			g3: ''
		},
		bv: {
			store: {
				dsg: {
					script: 'https://apps.bazaarvoice.com/deployments/dsg/main_site/staging/en_US/bv.js'
				},
				gg: {
					script: 'https://apps.bazaarvoice.com/deployments/golfgalaxy/main_site/staging/en_US/bv.js'
				},
				pl: {
					script: 'https://apps.bazaarvoice.com/deployments/publiclands/main_site/staging/en_US/bv.js'
				}
			}
		},
		soasta: {
			dsg: 'https://c.go-mpulse.net/boomerang/Y7NJM-H6YK3-37AQ8-UY6YB-3K3S9',
			gg: 'https://c.go-mpulse.net/boomerang/C5JH9-QVK3R-W7E4D-F63VJ-8WKUM',
			pl: '',
			g3: ''
		},
		scene7: {
			baseConfig: {
				baseUrl: 'https://dks.scene7.com/',
				cdn: 'GolfGalaxy/',
				css: 'skins/Scene7SharedAssets/htmlviewerskins/css/html5_mixedmediaviewer_light.css',
				imageDirectory: 'is/image/',
				queryString: '?req=set,json,UTF-8',
				sdkUrl: 's7sdk/3.3/js/s7sdk',
				secureBaseUrl: 'https://dks.scene7.com/',
				videoDirectory: 'is/content/',
				viewerUrl: 's7viewers/html5/js/MixedMediaViewer.js'
			},
			url: 'https://dks.scene7.com/is/image/dkscdn/',
			suffix: '$DSG_ProductCard$'
		},
		sessionCam: {
			enabled: false
		},
		searchDex: {
			gatewayUrlProxy: {
				path: `/dcsg-ngx-home/sdxincludes/api/`,
				timeout: '15000'
			},
			store: {
				calia: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				dsg: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				gg: {
					baseUrl: 'https://www.golfgalaxy.com/products/includes/'
				},
				pl: {
					baseUrl: 'https://www.publiclands.com/products/includes/'
				},
				g3: {
					baseUrl: 'https://www.goinggoinggone.com/products/includes/'
				}
			}
		},
		tealium: {
			enabled: true,
			script: {
				dsg: {
					baseUrl: 'https://tag.dickssportinggoods.com/qa/utag.js'
				},
				gg: {
					baseUrl: 'https://tag.golfgalaxy.com/qa/utag.js'
				},
				pl: {
					baseUrl: 'https://tag.publiclands.com/qa/utag.js'
				},
				g3: {
					baseUrl: 'https://tag.goinggoinggone.com/qa/utag.js'
				},
				calia: {
					baseUrl: 'https://tag.calia.com/qa/utag.js'
				}
			}
		}
	},
	myAccount: {
		authServiceBaseUrl: 'https://myaccount.dickssportinggoods.com/stage/authservice',
		logonApiKey: 'SgqA9WFTm7EamEfL1EwP3ObfFmau6ctZ',
		redirectPaths: {
			returnToMyAccount: {
				dsg: 'https://dickssportinggoods.app.link/NiMMrYEG9Hb',
				gg: 'https://golfgalaxy.app.link/FZMpGgAG9Hb',
				pl: '/MyAccount/AccountSummary',
				g3: '/MyAccount/AccountSummary'
			}
		}
	},
	feature: {
		...devEnvironmentDefaults.feature,
		dsg: {
			ceops: true,
			textSubscriptions: true,
			bopisProxyPickup: true,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: true
		},
		gg: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: true,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		},
		calia: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		},
		pl: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: false,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: false,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: false,
			hitTraxEnabled: false
		},
		vrst: {
			ceops: false,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		},
		g3: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		}
	},
	trackOrders: {
		scene7Url: 'https://dks.scene7.com/is/image/dkscdn/{0}/?$DSG_ShoppingCart$'
	},
	basePath: '.',
	baseUrls: {
		addressService: `${redirectingServiceBase}/addressservice`,
		athleteManagementService: `${redirectingServiceBase}/athletemanagementservice`,
		athleteProfileApi: `/api/v1/athletes/profile`,
		athleteService: `${redirectingServiceBase}/athleteservice`,
		authService: `${redirectingServiceBase}/authservice`,
		automatedToolingService: `${redirectingServiceBase}/automatedtoolingservice`,
		gameTimeApi: `/scheduling`,
		logonService: `${redirectingServiceBase}/logonservice`,
		mfaApi: `/api/v1/athletes/mfa`,
		orderService: `${redirectingServiceBase}/orderservice`,
		orders: '/v3/orders',
		partyService: `${redirectingServiceBase}/loyaltygateway/partyservice/ecomm`,
		pointService: `${redirectingServiceBase}/pointservice`,
		segmentationService: `${redirectingServiceBase}/segmentationservice`,
		textSubscriptionService: `https://externalcomm-textsubscriptionservice.dcsg.com`,
		consumerApi: `${redirectingServiceBase}/consumerapi`,
		identityService: '/athleterecord/services/redirectingservice/identityservice',
		emailValidationService: `${redirectingServiceBase}/emailvalidationservice`,
		batfittingService: `${redirectingServiceBase}/batfittingservice/`,
		passwordApi: `/api/v1/passwords`,
		sendPasswordResetLink: `/api/v1/athletes/emails`,
		creditApi: `${redirectingServiceBase}/creditcardservice`,
		verificationApi: `/api/v1/athletes/verification`,
		branchIoApi: 'https://api2.branch.io'
	},
	identityServiceKey: {
		partnerKey: 'MyAccount',
		secretKey: '8uBj3x2Zi3usl4PTiTyi'
	},
	creditServiceKey: {
		partnerKey: 'botf',
		secretKey: 'ASfCzTQyKvuuV8ocnzPP'
	},
	offerDate: {
		startDateString: '2020-12-10T23:59:59',
		endDateString: '2020-12-20T23:59:59'
	},
	isLocal: true,
	killSwitch: {
		crossChainBopis: {
			calia: false,
			dsg: true,
			gg: true,
			vrst: false,
			pl: false,
			g3: false
		},
		nikeConnectedEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		hitTraxEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		scorecardGoldEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: false,
			g3: true
		},
		listsEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: false
		},
		nikeConnectedSummaryEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		useNewSyfApi: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		inStoreDetailsEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		mfaEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		shareFavoritesEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: false
		},
		showDSRecommendations: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		showDSRecommendationsOD: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		skuFavoritesEnabled: {
			dsg: true,
			gg: true,
			pl: true
		},
		eventReservationsEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		dataDrivenListEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		shareListDeepLinkingEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		showDSRecommendationsFP: {
			dsg: false,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		trackOrderByEmailEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		giftcardCtaEnabled: {
			dsg: true,
			gg: true,
			pl: true,
			g3: true
		},
		nudgeShareEnabled: {
			dsg: true,
			gg: true,
			pl: true
		},
		oosListEnabled: {
			dsg: true,
			gg: true,
			pl: true
		},
		useAuthGuardSetInterval: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		enableTooltipSurvey: {
			dsg: true,
			gg: true,
			pl: false,
			g3: false
		},
		orderAlertsSettingsEnabled: {
			dsg: false,
			gg: false,
			pl: false
		},
		rewardsUxRedesignEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		nflPreferencesEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		btsDashUpdates: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		}
	}
};

export interface IEnvironment {
	api: any;
	apiAuthKeys: {
		partnerKey: string;
		secretKey: string;
	};
	apiTokens: any;
	basePath: string;
	baseUrls: {
		addressService: string;
		athleteManagementService: string;
		athleteProfileApi: string;
		athleteService: string;
		authService: string;
		automatedToolingService: string;
		batfittingService: string;
		branchIoApi: string;
		consumerApi: string;
		creditApi: string;
		emailValidationService: string;
		gameTimeApi: string;
		identityService: string;
		logonService: string;
		mfaApi: string;
		orderService: string;
		orders: string;
		partyService: string;
		passwordApi: string;
		pointService: string;
		segmentationService: string;
		sendPasswordResetLink: string;
		textSubscriptionService: string;
		verificationApi: string;
	};
	catOvrGrpId: {
		dsg: string;
		g3: string;
		gg: string;
		pl: string;
	};
	creditServiceKey: {
		partnerKey: string;
		secretKey: string;
	};
	environmentName: string;
	esbEnvironmentHeader: string;
	feature: any;
	identityServiceKey: {
		partnerKey: string;
		secretKey: string;
	};
	inventory: {
		locationId: number;
	};
	isLocal: boolean;
	killSwitch: any;
	logging: {
		client: {
			level: LoggerLevel;
		};
		xhr: {
			level: LoggerLevel;
			url: string;
		};
	};
	myAccount: {
		authServiceBaseUrl: string;
		logonApiKey: string;
		redirectPaths: {
			returnToMyAccount: any;
		};
	};
	offerDate: {
		endDateString: string;
		startDateString: string;
	};
	pricing: any;
	production: boolean;
	searchbyTermTypeParam: string;
	thirdParty: {
		auth0: any;
		btt: {
			dsg: string;
			g3: string;
			gg: string;
			pl: string;
		};
		bv: {
			store: {
				dsg: {
					script: string;
				};
				gg: {
					script: string;
				};
				pl: {
					script: string;
				};
			};
		};
		scene7: {
			baseConfig: any;
			suffix: string;
			url: string;
		};
		searchDex: {
			gatewayUrlProxy: {
				path: string;
				timeout: string;
			};
			store: {
				calia: {
					baseUrl: string;
				};
				dsg: {
					baseUrl: string;
				};
				g3: {
					baseUrl: string;
				};
				gg: {
					baseUrl: string;
				};
				pl: {
					baseUrl: string;
				};
			};
		};
		sessionCam: {
			enabled: boolean;
		};
		soasta: {
			dsg: string;
			g3: string;
			gg: string;
			pl: string;
		};
		tealium: {
			enabled: boolean;
			script: {
				calia: {
					baseUrl: string;
				};
				dsg: {
					baseUrl: string;
				};
				g3: {
					baseUrl: string;
				};
				gg: {
					baseUrl: string;
				};
				pl: {
					baseUrl: string;
				};
			};
		};
	};
	trackOrders: {
		scene7Url: string;
	};
}
